type ApiError = {
  response?: { data?: { message?: string } };
  message?: string;
};

export function extractErrorMessage(error: unknown, fallback: string): string {
  const e = error as ApiError;
  return e?.response?.data?.message ?? e?.message ?? fallback;
}
